import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate } from 'react-router-dom';

const BrandPartyDiscountList = () => {
    const [discounts, setDiscounts] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    // Fetch brand party discounts on component mount
    useEffect(() => {
        fetch(`${BASE_URL}brandpartydiscount`)
            .then(response => response.json())
            .then(data => {
                if (data.status === "success") {
                    setDiscounts(data.data); // Set the fetched discounts data
                }
            })
            .catch(error => console.error('Error fetching brand party discounts:', error));
    }, []);

    // Handle search term change
    const handleSearchChange = (event) => {
        const term = event.target.value;
        setSearchTerm(term);

        // Filter discounts based on the search term
        const filteredDiscounts = discounts.filter(discount =>
            discount.party_name.toLowerCase().includes(term.toLowerCase()) ||
            discount.brand_name.toLowerCase().includes(term.toLowerCase())
        );
        setDiscounts(filteredDiscounts);
    };

    // Navigate to the edit page for a discount
    const handleEdit = (id) => {
        navigate(`/EditBrandPartyDiscount/${id}`);
    };

    // Navigate to the add discount page
    const handleAdd = () => {
        navigate('/AddBrandPartyDiscount');
    };

    // Handle delete of discount
    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this discount?")) {
            fetch(`${BASE_URL}brandpartydiscount/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status === "success") {
                        // Remove the deleted discount from the list
                        setDiscounts(discounts.filter(discount => discount.id !== id));
                    }
                })
                .catch(error => console.error('Error deleting discount:', error));
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Brand Party Discount List</h3>
                        </div>
                    </div>
                </div>
            </div>

            {/* Basic Tables start */}
            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6">
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <button className="btn btn-primary" onClick={handleAdd}>Add Discount</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="mb-3">
                                    <label htmlFor="searchTerm" className="form-label">Search by Party or Brand</label>
                                    <input
                                        type="text"
                                        id="searchTerm"
                                        className="form-control"
                                        placeholder="Search by party or brand"
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                    />
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-lg">
                                        <thead>
                                            <tr>
                                                <th>SNO</th>
                                                <th>PARTY CODE</th>
                                                <th>PARTY NAME</th>
                                                <th>BRAND CODE</th>
                                                <th>BRAND NAME</th>
                                                <th>DESCRIPTION</th>
                                                <th>DATE</th>
                                                <th className="text-end">ACTION</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {discounts.map(discount => (
                                                <tr key={discount.id}>
                                                    <td>{discount.sno}</td>
                                                    <td>{discount.party_code}</td>
                                                    <td>{discount.party_name}</td>
                                                    <td>{discount.brand_code}</td>
                                                    <td>{discount.brand_name}</td>
                                                    <td>{discount.description}</td>
                                                    <td>{new Date(discount.date).toLocaleDateString()}</td>
                                                    <td className="text-end">
                                                        <button className="btn btn-success" onClick={() => handleEdit(discount.id)}>Edit</button>
                                                        <button className="btn btn-danger ms-2" onClick={() => handleDelete(discount.id)}>Delete</button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Basic Tables end */}
        </div>
    );
};

export default BrandPartyDiscountList;
